export const translations = {
  codigoSap: {
    pt: "Código ERP",
    en: "ERP Code",
    es: "Código ERP",
    de: "ERP-Code",
  },
  codigo: {
    pt: "Código",
    en: "Code",
    es: "Código",
    de: "Code",
  },
  descricao: {
    pt: "Adicione abaixo a equipe comercial referente a esse cliente.",
    en: "Add the commercial team below for this client.",
    es: "Agregue abajo el equipo comercial referente a este cliente.",
    de: "Fügen Sie unten das Vertriebsteam für diesen Kunden hinzu.",
  },
  adicionar: {
    pt: "Adicionar",
    en: "Add",
    es: "Agregar",
    de: "Hinzufügen",
  },
  timeComercial: {
    pt: "Time Comercial",
    en: "Commercial Team",
    es: "Equipo Comercial",
    de: "Vertriebsteam",
  },
}
